import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaTwitter, FaLinkedin } from "react-icons/fa";

const ContactUs = () => {
  return (
    <Container className="py-5">
      <h2 className="text-center mb-4">Contact Us</h2>
      <Row>
        {/* 左侧联系信息 */}
        <Col md={5} className="mb-4">
          <h4>Get in Touch</h4>
          <p><FaMapMarkerAlt /> 123 Main Street, City, Country</p>
          <p><FaPhone /> +123 456 7890</p>
          <p><FaEnvelope /> contact@example.com</p>
          <div className="d-flex gap-3 mt-3">
            <a href="#" className="text-dark"><FaFacebook size={24} /></a>
            <a href="#" className="text-dark"><FaTwitter size={24} /></a>
            <a href="#" className="text-dark"><FaLinkedin size={24} /></a>
          </div>
        </Col>
        
        {/* 右侧联系表单 */}
        <Col md={7}>
          <Form>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" placeholder="Enter your name" required />
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" placeholder="Enter your email" required />
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="message">
              <Form.Label>Message</Form.Label>
              <Form.Control as="textarea" rows={4} placeholder="Enter your message" required />
            </Form.Group>
            
            <Button variant="primary" type="submit">Send Message</Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactUs;
